import AvgPay from "./AvgPay";
import CalculateMonthlyNetPay from "./CalculateMonthlyNetPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    Net_Pay: number | string | null;
    End_date?: any;
    Start_date?: any;
  }

interface EmployerSource {
    "files":payRecords[];
}
export const TotalNetPay =(EmployerSources:EmployerSource[])=>{
    const totalNetPay = EmployerSources.reduce((acc, curr) => {
        const total= acc + AvgPay(CalculateMonthlyNetPay(curr.files),curr.files);
        return total;
    }, 0)
    return totalNetPay;
}